module.exports = __webpack_public_path__ + "img/coupon-3-fill.5a07e689.svg";